import { Typography } from "@circle-react/components/shared/uikit/Typography";
import type { ReactNode } from "react";

export interface HeaderProps {
  children: ReactNode;
}

export const Header = ({ children }: HeaderProps) => (
  <div className="flex items-center px-3 py-2">
    <Typography.LabelXsPlus color="text-lightest" weight="medium">
      {children}
    </Typography.LabelXsPlus>
  </div>
);
